/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DisplayHtmlContent, ReadMoreBlock } from 'sarsaparilla';
import { ContentProps } from '../props/contents';

export default class LEGACY_Overview extends PureComponent {
    static defaultProps = {
        overview: [],
    };

    static propTypes = {
        overview: PropTypes.arrayOf(ContentProps),
    };

    render() {
        const { overview } = this.props;
        const [item] = overview;
        const paragraphs = item?.paragraphs;
        return (
            <div className={'parkpass-pass-overview'}>
                <ReadMoreBlock
                    className={'parkpass-pass-overview-container'}
                    id={'parkpass-pass-overview'}
                    lineHeight={23}
                    linesToShow={5}
                >
                    {paragraphs?.map((paragraph, index) => {
                        return (
                            <DisplayHtmlContent
                                key={`overview-paragraph-${index}`}
                                html={`<p>${paragraph}</p>`}
                            />
                        );
                    })}
                </ReadMoreBlock>
            </div>
        );
    }
}

// cspell:ignore parkpass
